/*
  prodotto-multipla-stampe.js — le foto del cliente dentro le cornici multiple e, se le vuole,
  la loro stampa, una per finestra della maschera (snippets/prodotto-multipla-stampe.liquid).

  IL DISEGNO (10/10/2026, Andrea: «la foto direttamente dentro la cornice»): ogni cornice con
  la texture della sua asta e la foto nella finestra, sotto il riflesso della lastra. Le
  funzioni sono quelle del configuratore (9-slice dell'asta, foto a copertura, effetto
  vetro/crilex, cornice a colori finche' l'immagine non c'e'): il prototipo di
  FOTORECORD.CLASSES.aste, caricato in differita da configuratore-pricing.js +
  configuratore-universale.js (gli URL li da' lo snippet). Nessuna copia del disegno: se il
  motore non si carica, le cornici restano col colore pieno e le foto si vedono lo stesso.
  I posti sono i box sotto l'immagine (assets/foto-posti.css, gli stessi del configuratore
  multifoto): la tastiera e i lettori di schermo li trovano come ogni altro pulsante; le
  finestre sul disegno ne sono scorciatoie (`data-scorciatoia`). Il disegno sta nella
  colonna delle immagini, al posto della galleria (parte «anteprima» dello snippet); la
  scelta della stampa, lo stato e gli avvisi accanto al carrello.

  LE FOTO: ogni finestra apre la scelta del file (JPG/PNG, max 20 MB; sotto i 150 ppi solo
  un avviso, con la stampa scelta). Ogni posto ha il suo verso (`data-verso`: v, o, niente per
  i quadrati) e una foto dell'altro verso non entra (10/10/2026); le Agmax-ZEP non hanno
  disegno (le misure non le sappiamo esatte) ma un elenco di posti (`data-mul-posti`), e se si
  appendono nei due sensi il cliente sceglie «come in foto» o «girata». Con «Solo la cornice» servono solo a vedere l'effetto e
  il form di Dawn aggiunge la multipla come sempre. Con le stampe scelte, all'invio del form
  (in cattura, prima di product-form.js) servono tutte; poi una riga «Stampa fotografica» per
  finestra su /cart/add.js (multipart: Shopify salva il file e ne mette l'URL in «Foto da
  stampare»), con «Per la cornice», «Posizione» e lo stesso `_bundle`, che va anche sul form
  della multipla, rinviato subito dopo. Le regole della foto sono quelle di
  prodotto-standard-stampa.js.
*/
(() => {
  // le parti dello snippet: la scelta accanto al carrello; il disegno (nostre multiple, kit
  // multifoto) oppure l'elenco dei posti (Agmax-ZEP, niente misure: 10/10/2026)
  const box = document.querySelector('[data-mul-stampe]');
  const anteprima = document.querySelector('[data-mul-anteprima]');
  const posti = document.querySelector('[data-mul-posti]');
  if (!box || !posti) return;
  const form = document.getElementById(box.dataset.formId);
  if (!form) return;

  const MAX_BYTE = 20 * 1024 * 1024;
  const PPI_MIN = 150;
  // Lo sfondo di un prodotto e' bianco puro (Andrea, 11/10/2026), come le foto di catalogo
  // delle multiple: il disegno sta dove sta la galleria e deve sembrarne una foto.
  const SFONDO = '#ffffff';
  const SENZA_ASTA = '#d6d2ca';      // le multiple senza `aste` (Agmax): uno schema chiaro, la foto vera e' nella galleria
  const PASSEPARTOUT = '#fbfaf8';    // il cartone bianco del passepartout (kit multifoto)
  // Un foro ancora vuoto dice la misura della foto che ci va, come le foto di catalogo delle
  // multiple (Andrea, 11/10/2026): fondo grigio chiaro, misura nel font dei titoli.
  const FORO = '#e9e8e6';
  const INCHIOSTRO = '#1a1a1a';
  const FONT_MISURA = '"Zilla Slab", Rockwell, "Roboto Slab", Georgia, serif';
  const guida = document.querySelector('[data-mul-guida]');
  const campoFile = document.querySelector('[data-mul-stampe-file]');
  const stato = box.querySelector('.mul-stampe__stato');
  const avviso = box.querySelector('.mul-stampe__avviso');
  // i box dei posti sono l'elenco (assets/foto-posti.css); sul disegno, le finestre ne sono scorciatoie
  const finestre = [...posti.querySelectorAll('[data-finestra]')];
  const scorciatoia = (i) => (anteprima ? anteprima.querySelector(`[data-scorciatoia="${i}"]`) : null);
  const segnaPiena = (g, piena) => {
    g.classList.toggle('foto-posti__posto--piena', piena);
    const s = scorciatoia(g.dataset.finestra);
    if (s) s.classList.toggle('mul-anteprima__finestra--piena', piena);
  };
  const foto = new Map();          // numero finestra -> File
  const immagini = new Map();      // numero finestra -> HTMLImageElement
  const piccole = new Map();       // numero finestra -> ppi, se sotto la soglia
  let scelta = '';
  let corrente = null;
  let lasciaPassare = false;
  let girata = false;              // la multipla si appende girata: i versi si scambiano
  let disegna = () => {};          // il disegno c'e' solo con le misure

  /* ── il verso di ogni posto (10/10/2026, su tutte le multiple) ── */
  const VERSO = { v: 'verticale', o: 'orizzontale' };
  const SPIEGA = { v: 'più alta che larga', o: 'più larga che alta' };
  // l'avviso sul posto stesso, sotto il suo box (Andrea, 12/10/2026): accanto al carrello
  // stava lontano dai box e la foto rifiutata sembrava sparita senza motivo
  const avvisoPosto = (g, testo) => {
    const li = g.closest('li') || g.parentElement;
    let p = li.querySelector('.foto-posti__avviso');
    if (!p && testo) {
      p = document.createElement('p');
      p.className = 'foto-posti__avviso';
      p.setAttribute('role', 'alert');
      li.appendChild(p);
    }
    if (p) { p.textContent = testo; p.hidden = !testo; }
    g.classList.toggle('foto-posti__posto--rifiutata', Boolean(testo));
  };
  const versoDi = (g) => {
    const v = g.dataset.verso || '';
    return girata && v ? (v === 'v' ? 'o' : 'v') : v;
  };
  const versoFoto = (img) => (img.naturalHeight > img.naturalWidth * 1.05 ? 'v'
    : img.naturalWidth > img.naturalHeight * 1.05 ? 'o' : '');
  const etichetta = (g) => `${g.dataset.formato}${versoDi(g) ? ` ${VERSO[versoDi(g)]}` : ''}`;
  const aggiornaEtichette = () => finestre.forEach((g) => {
    const testo = g.querySelector('[data-verso-testo]');
    if (testo) testo.textContent = versoDi(g) ? VERSO[versoDi(g)] : '';
    const piena = foto.has(Number(g.dataset.finestra));
    g.setAttribute('aria-label', `Foto ${g.dataset.finestra} di ${finestre.length}, stampa ${etichetta(g)}${piena ? ': cambia la foto' : ''}`);
  });

  /* ── il disegno ── */
  if (anteprima) {
  const dati = JSON.parse(document.querySelector('[data-mul-dati]').textContent);
  const canvas = anteprima.querySelector('canvas');
  const bordo = parseFloat(anteprima.dataset.bordo) || 0;
  const [W, H] = dati.esterno;
  const profili = dati.profili || {};
  const aste = dati.aste || [];
  const fronti = dati.fronti || [];
  const texture = {};              // id asta -> { img, pattern }
  const fogli = new Map();         // indice finestra (da 0) -> foglio segnaposto, se il prodotto lo ha
  let pittore = null;              // il prototipo del configuratore, quando c'e'

  const dentro = (c, f) => c[0] <= f.x && c[1] <= f.y && f.x + f.b <= c[0] + c[2] && f.y + f.h <= c[1] + c[3];
  const pezzi = dati.cornici.map((c, i) => ({
    r: c,
    finestre: dati.finestre.map((f, n) => (dentro(c, f) ? n : -1)).filter((n) => n >= 0),
    asta: aste[i] || '',
    fronte: fronti[i] || '',
    // col passepartout (11/10/2026): la luce della cornice, l'apertura del legno, i colori
    luce: (dati.luci || [])[i] || null,
    legno: (dati.legni || [])[i] || null,
    cartone: (dati.cartoni || [])[i] || '',
    coloreLegno: (dati.colori_legno || [])[i] || null,
  }));

  const copri = (ctx, img, x, y, w, h) => {
    if (pittore) return pittore._drawImgCover(ctx, img, x, y, w, h);
    const k = Math.max(w / img.naturalWidth, h / img.naturalHeight);
    ctx.save();
    ctx.beginPath(); ctx.rect(x, y, w, h); ctx.clip();
    ctx.drawImage(img, x + (w - img.naturalWidth * k) / 2, y + (h - img.naturalHeight * k) / 2,
      img.naturalWidth * k, img.naturalHeight * k);
    ctx.restore();
  };

  disegna = () => {
    const cssW = anteprima.clientWidth;
    if (!cssW) return;
    const dpr = Math.min(window.devicePixelRatio || 1, 3);
    const s = cssW / (W + 2 * bordo);                       // px per mm
    const cssH = (H + 2 * bordo) * s;
    canvas.width = Math.round(cssW * dpr);
    canvas.height = Math.round(cssH * dpr);
    const ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.fillStyle = SFONDO;
    ctx.fillRect(0, 0, cssW, cssH);
    const px = (v) => (v + bordo) * s;

    // la fascia di un'asta: 9-slice con la sua texture, o il colore pieno finche' non c'e'
    const fascia = (p, x, y, w, h, larga) => {
      const prof = profili[p.asta];
      const t = texture[p.asta];
      if (pittore && t && t.img) {
        const slice = t.img.naturalWidth * ((prof.larghezza_sezione_mm || 20) / 200);
        pittore._draw9Slice(ctx, t.img, slice, x, y, w, h, larga, t.pattern);
      } else if (pittore) {
        const colore = prof ? pittore._fallbackColor(prof.colore) : SENZA_ASTA;
        pittore._drawCorniceFallback(ctx, colore, x, y, w, h, larga);
      } else {
        ctx.save();
        ctx.fillStyle = prof ? (window.FOTORECORD?.coloreHex?.(prof.colore, SENZA_ASTA) || SENZA_ASTA) : SENZA_ASTA;
        ctx.beginPath();
        ctx.rect(x, y, w, h);
        ctx.rect(x + larga, y + larga, w - 2 * larga, h - 2 * larga);
        ctx.fill('evenodd');
        ctx.restore();
      }
    };
    // un foro: la foto del cliente, o il foglio segnaposto, o la misura della foto che ci va
    const foro = (p, n) => {
      const f = dati.finestre[n];
      const [fx, fy, fw, fh] = [px(f.x), px(f.y), f.b * s, f.h * s];
      const img = immagini.get(n + 1) || fogli.get(n);
      if (img) {
        // il foglio e' grande quanto la foto: come nella cornice vera, il bordo va sotto
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(fx, fy, fw, fh);
        copri(ctx, img, fx, fy, fw, fh);
      } else {
        ctx.fillStyle = FORO;
        ctx.fillRect(fx, fy, fw, fh);
        ctx.fillStyle = INCHIOSTRO;
        ctx.font = `700 ${Math.max(9, Math.round(Math.min(fw * 0.22, fh * 0.3)))}px ${FONT_MISURA}`;
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(f.formato || '', fx + fw / 2, fy + fh / 2);
      }
      if (pittore && p.fronte) {
        pittore.state = { config: { fronte: { tipo: p.fronte } } };
        pittore._drawFronteEffetto(ctx, fx, fy, fw, fh);
      }
    };

    pezzi.forEach((p) => {
      const [x, y, w, h] = [px(p.r[0]), px(p.r[1]), p.r[2] * s, p.r[3] * s];
      // l'ombra di ogni cornice e' quella del configuratore e delle immagini del sito
      // (pittore._ombraCornice → FOTORECORD.core.ombraCornice, 24/10/2026); finche' il motore
      // non c'e', nessuna ombra — come la texture, arriva col motore
      if (pittore) pittore._ombraCornice(ctx, x, y, w, h);
      ctx.fillStyle = '#ccc';
      ctx.fillRect(x, y, w, h);
      if (p.finestre.length === 1) {
        // una cornice per foto (le nostre multiple): la fascia e' la cornice, il foro la luce
        const f = dati.finestre[p.finestre[0]];
        if (p.luce) {
          // col passepartout: cartone nella luce, il legno attorno al suo foro, poi la cornice
          const [lx, ly, lw, lh] = p.luce;
          ctx.fillStyle = p.cartone || PASSEPARTOUT;
          ctx.fillRect(px(lx), px(ly), lw * s, lh * s);
          if (p.coloreLegno && p.legno) {
            const [gx, gy, gw, gh] = p.legno;
            ctx.save();
            ctx.fillStyle = p.coloreLegno.colore;
            ctx.beginPath();
            ctx.rect(px(lx), px(ly), lw * s, lh * s);
            ctx.rect(px(gx), px(gy), gw * s, gh * s);
            ctx.fill('evenodd');
            if (p.coloreLegno.filo) {
              ctx.strokeStyle = p.coloreLegno.filo; ctx.lineWidth = Math.max(1, 1.5 * s);
              ctx.strokeRect(px(gx) - 2 * s, px(gy) - 2 * s, gw * s + 4 * s, gh * s + 4 * s);
            }
            ctx.restore();
          }
          foro(p, p.finestre[0]);
          fascia(p, x, y, w, h, ((p.r[2] - lw) / 2 + (p.r[3] - lh) / 2) / 2 * s);
        } else {
          fascia(p, x, y, w, h, ((p.r[2] - f.b) / 2 + (p.r[3] - f.h) / 2) / 2 * s);
          foro(p, p.finestre[0]);
        }
      } else if (p.asta && dati.passepartout) {
        // un passepartout a piu' fori dentro una cornice (kit multifoto, 11/10/2026): prima
        // il cartone coi fori, poi la cornice sopra, larga quanto la sezione dell'asta
        const [qx, qy, qw, qh] = dati.passepartout;
        ctx.fillStyle = PASSEPARTOUT;
        ctx.fillRect(px(qx), px(qy), qw * s, qh * s);
        p.finestre.forEach((n) => foro(p, n));
        if (dati.legno) {
          // il passepartout in legno (11/10/2026): la fascia fra la cornice e il cartone, col filo
          const L = dati.legno;
          const [ex, ey, ew, eh] = L.esterno, [ix, iy, iw, ih] = L.interno;
          ctx.save();
          ctx.fillStyle = L.colore;
          ctx.beginPath();
          ctx.rect(px(ex), px(ey), ew * s, eh * s);
          ctx.rect(px(ix), px(iy), iw * s, ih * s);
          ctx.fill('evenodd');
          ctx.strokeStyle = 'rgba(0,0,0,0.18)'; ctx.lineWidth = 1;
          ctx.strokeRect(px(ix) - 0.5, px(iy) - 0.5, iw * s + 1, ih * s + 1);
          if (L.filo) {
            ctx.strokeStyle = L.filo; ctx.lineWidth = Math.max(1, 1.5 * s);
            ctx.strokeRect(px(ix) - 2 * s, px(iy) - 2 * s, iw * s + 4 * s, ih * s + 4 * s);
          }
          ctx.restore();
        }
        const sez = (profili[p.asta] && profili[p.asta].larghezza_sezione_mm) || ((p.r[2] - qw) / 2);
        fascia(p, x, y, w, h, sez * s);
      } else {
        ctx.fillStyle = PASSEPARTOUT;
        ctx.fillRect(x, y, w, h);
        ctx.strokeStyle = 'rgba(0,0,0,0.25)'; ctx.lineWidth = 1;
        ctx.strokeRect(x + 0.5, y + 0.5, w - 1, h - 1);
        p.finestre.forEach((n) => foro(p, n));
      }
    });
  };

  const caricaImg = (url) => new Promise((ok) => {
    if (!url) return ok(null);
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => ok(img);
    img.onerror = () => ok(null);
    img.src = url;
  });

  const caricaScript = (src) => new Promise((ok, ko) => {
    const el = document.createElement('script');
    el.src = src;
    el.onload = ok;
    el.onerror = ko;
    document.head.appendChild(el);
  });

  const caricaMotore = async () => {
    const FR = window.FOTORECORD || {};
    try {
      if (!FR.PRICING_SSOT) await caricaScript(dati.motore[0]);
      if (!(window.FOTORECORD && window.FOTORECORD.CLASSES)) await caricaScript(dati.motore[1]);
      if (!(window.FOTORECORD && window.FOTORECORD.core)) await caricaScript(dati.motore[2]);   // l'ombra delle cornici
      const proto = window.FOTORECORD.CLASSES.aste.prototype;
      // un pittore senza stato: solo i metodi di disegno; _effettoImg acceso = c'e' una lastra
      pittore = Object.assign(Object.create(proto), { _effettoImg: true });
    } catch (e) {
      return;   // il disegno resta a colori pieni, le foto si vedono lo stesso
    }
    disegna();
    await Promise.all([...new Set(aste)].filter((a) => profili[a]).map(async (a) => {
      const [img, pattern] = await Promise.all([caricaImg(profili[a].immagine_url), caricaImg(profili[a].pattern_url)]);
      texture[a] = { img, pattern };
    }));
    disegna();
  };

  disegna();
  // i fogli segnaposto dei fori (custom.segnaposto_fori, ADR 2026-10-14): subito, sono la
  // prima cosa che si vede; finche' non arrivano il foro dice la sua misura
  (dati.segnaposti || []).forEach((url, n) => caricaImg(url).then((img) => {
    if (img) { fogli.set(n, img); disegna(); }
  }));
  if ('ResizeObserver' in window) new ResizeObserver(() => disegna()).observe(anteprima);
  const avvia = () => { caricaMotore(); };
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((voci) => {
      if (voci.some((v) => v.isIntersecting)) { io.disconnect(); avvia(); }
    }, { rootMargin: '300px' });
    io.observe(anteprima);
  } else {
    avvia();
  }
  }

  /* ── le foto ── */
  const aggiornaStato = () => {
    const righe = [`${foto.size} di ${finestre.length} foto nelle cornici.`];
    if (scelta) piccole.forEach((ppi, i) => righe.push(`La foto ${i} è piccola per la sua stampa: si vedrà meno nitida (${ppi} ppi, ne servono almeno ${PPI_MIN}).`));
    stato.textContent = foto.size || scelta ? righe.join(' ') : '';
  };

  const campoBundle = (valore) => {
    let campo = form.querySelector('input[name="properties[_bundle]"]');
    if (!valore) {
      if (campo) campo.remove();
      return;
    }
    if (!campo) {
      campo = document.createElement('input');
      campo.type = 'hidden';
      campo.name = 'properties[_bundle]';
      form.appendChild(campo);
    }
    campo.value = valore;
  };

  box.addEventListener('change', (e) => {
    if (e.target.name !== 'mul-stampe-scelta') return;
    scelta = e.target.value;
    guida.textContent = scelta ? guida.dataset.stampa : guida.dataset.prova;
    avviso.textContent = '';
    if (!scelta) campoBundle('');
    aggiornaStato();
  });

  // le Agmax che si appendono nei due sensi: «come in foto» o «girata»; con le foto gia'
  // caricate, quelle che non hanno piu' il verso del loro posto si tolgono e si dice
  if (posti) posti.addEventListener('change', (e) => {
    if (e.target.name !== 'mul-senso') return;
    girata = e.target.value === 'girata';
    const via = [];
    immagini.forEach((img, i) => {
      const g = finestre.find((x) => Number(x.dataset.finestra) === i);
      const vp = versoDi(g), vf = versoFoto(img);
      if (vp && vf && vp !== vf) {
        URL.revokeObjectURL(img.src);
        immagini.delete(i); foto.delete(i); piccole.delete(i);
        segnaPiena(g, false);
        const mini = g.querySelector('img');
        if (mini) { mini.hidden = true; mini.removeAttribute('src'); }
        avvisoPosto(g, `Con la cornice girata questo posto vuole una foto ${VERSO[versoDi(g)]}: caricala di nuovo.`);
        via.push(i);
      }
    });
    aggiornaEtichette();
    aggiornaStato();
    avviso.textContent = via.length
      ? `Con la cornice girata cambiano i posti verticali e orizzontali: carica di nuovo ${via.length > 1 ? 'le foto' : 'la foto'} ${via.join(', ')}.`
      : '';
  });

  const apri = (g) => {
    corrente = g;
    campoFile.value = '';
    campoFile.click();
  };
  finestre.forEach((g) => g.addEventListener('click', () => apri(g)));
  if (anteprima) anteprima.querySelectorAll('[data-scorciatoia]').forEach((s) => s.addEventListener('click', () => {
    const g = finestre.find((x) => x.dataset.finestra === s.dataset.scorciatoia);
    if (g) apri(g);
  }));
  aggiornaEtichette();

  const controllaRisoluzione = (g, img) => {
    const [a, b] = g.dataset.formato.replace(' cm', '').split('x').map((n) => parseFloat(n.replace(',', '.')));
    const lati = [Math.max(a, b) / 2.54, Math.min(a, b) / 2.54];
    const pixel = [Math.max(img.naturalWidth, img.naturalHeight), Math.min(img.naturalWidth, img.naturalHeight)];
    const ppi = Math.min(pixel[0] / lati[0], pixel[1] / lati[1]);
    const i = Number(g.dataset.finestra);
    if (ppi < PPI_MIN) piccole.set(i, Math.round(ppi));
    else piccole.delete(i);
  };

  campoFile.addEventListener('change', () => {
    const g = corrente;
    const file = campoFile.files[0];
    if (!g || !file) return;
    avviso.textContent = '';
    if (!/^image\/(jpeg|png)$/.test(file.type)) {
      avviso.textContent = 'Serve un file JPG o PNG.';
      return;
    }
    if (file.size > MAX_BYTE) {
      avviso.textContent = 'Il file supera i 20 MB: scegline uno più leggero.';
      return;
    }
    const i = Number(g.dataset.finestra);
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      // il verso: una foto orizzontale in un posto verticale si taglierebbe a meta'
      const vp = versoDi(g), vf = versoFoto(img);
      if (vp && vf && vp !== vf) {
        URL.revokeObjectURL(url);
        avvisoPosto(g, `Questo posto vuole una foto ${VERSO[vp]} (${SPIEGA[vp]}): scegline una così.`);
        return;
      }
      avvisoPosto(g, '');
      const vecchia = immagini.get(i);
      if (vecchia) URL.revokeObjectURL(vecchia.src);
      immagini.set(i, img);
      foto.set(i, file);
      segnaPiena(g, true);
      const mini = g.querySelector('img');
      if (mini) { mini.src = url; mini.hidden = false; }
      aggiornaEtichette();
      controllaRisoluzione(g, img);
      aggiornaStato();
      disegna();
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      avviso.textContent = 'Questa foto non si apre: prova con un altro file JPG o PNG.';
    };
    img.src = url;
  });

  document.addEventListener('submit', async (e) => {
    if (e.target !== form || !scelta) return;
    if (lasciaPassare) {
      lasciaPassare = false;
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    const vuota = finestre.find((g) => !foto.has(Number(g.dataset.finestra)));
    if (vuota) {
      avviso.textContent = `Manca la foto ${vuota.dataset.finestra}: caricale tutte, oppure scegli «Solo la cornice».`;
      vuota.focus();
      return;
    }

    const bundle = `mul-${Date.now().toString(36)}${Math.random().toString(36).slice(2, 6)}`;
    // getAttribute, non form.id: il form di Dawn ha un campo name="id" (la variante) e
    // form.id restituisce quel campo, il selettore non trovava le copie e le stampe
    // entravano sempre x1 (14/10/2026)
    const quantita = document.querySelector(`input[name="quantity"][form="${form.getAttribute('id')}"]`) || form.querySelector('input[name="quantity"]');
    const copie = parseInt(quantita && quantita.value, 10) || 1;
    const pulsante = form.querySelector('[type="submit"]');
    if (pulsante) pulsante.classList.add('loading');
    let entrate = 0;
    try {
      for (const g of finestre) {
        const i = Number(g.dataset.finestra);
        const righe = new FormData();
        righe.append('id', g.dataset.variante);
        righe.append('quantity', String(copie));
        righe.append('properties[Foto da stampare]', foto.get(i));
        righe.append('properties[Per la cornice]', box.dataset.cornice);
        righe.append('properties[Posizione]', `foto ${i} di ${finestre.length}${versoDi(g) ? `, ${VERSO[versoDi(g)]}` : ''}`);
        righe.append('properties[_bundle]', bundle);
        righe.append('properties[_stampa_tipo]', 'foto');
        righe.append('properties[_stampa_sku]', g.dataset.sku);
        const risposta = await fetch('/cart/add.js', {
          method: 'POST',
          body: righe,
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        });
        if (!risposta.ok) {
          const errore = await risposta.json().catch(() => ({}));
          throw new Error(errore.description || `errore ${risposta.status}`);
        }
        entrate += 1;
        stato.textContent = `Carico le foto: ${entrate} di ${finestre.length}…`;
      }
    } catch (err) {
      avviso.textContent = entrate
        ? `Sono entrate nel carrello ${entrate} stampe su ${finestre.length}, poi si è fermato (${err.message}): controlla il carrello e riprova.`
        : `Le stampe non sono entrate nel carrello (${err.message}): riprova.`;
      if (pulsante) pulsante.classList.remove('loading');
      return;
    }
    if (pulsante) pulsante.classList.remove('loading');
    stato.textContent = `Le ${finestre.length} stampe sono nel carrello.`;
    campoBundle(bundle);
    lasciaPassare = true;
    form.requestSubmit();
  }, true);
})();
